import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing auth session
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    // Mock login - replace with real authentication
    const mockUser = {
      id: 1,
      email,
      name: email.split('@')[0],
      role: 'user',
      avatar: `https://ui-avatars.com/api/?name=${email}&background=DC2626&color=fff`,
      address: {
        street: '123 Main St',
        city: 'Houston',
        state: 'TX',
        zipCode: '77002'
      }
    };
    setUser(mockUser);
    localStorage.setItem('user', JSON.stringify(mockUser));
    return mockUser;
  };

  const signup = async (userData) => {
    // Mock signup - replace with real authentication
    const newUser = {
      id: Date.now(),
      ...userData,
      avatar: `https://ui-avatars.com/api/?name=${userData.name}&background=DC2626&color=fff`,
      address: userData.street ? {
        street: userData.street,
        city: userData.city,
        state: userData.state,
        zipCode: userData.zipCode
      } : null
    };
    setUser(newUser);
    localStorage.setItem('user', JSON.stringify(newUser));
    return newUser;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  const value = {
    user,
    login,
    signup,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};